import {SidebarMenuMain} from './SidebarMenuMain'
import clsx from "clsx";

const SidebarMenu = () => {
    return (
        <div id='#kt_aside_menu'
             data-kt-menu='true'
             className={clsx(
                 'menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500')}>
            <SidebarMenuMain/>
        </div>
    )
}

export {SidebarMenu}
